"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoomiOrderCancelSchema = void 0;
const boomi_order_default_1 = require("./boomi-order-default");
const EVENT_INFO_DEFINITION = {
    properties: {
        isTrial: {
            type: 'boolean'
        },
        autoRenewStatusChangeDate: {
            type: 'string'
        },
        expiresDate: {
            type: 'string',
            minLength: 10
        },
    },
    required: [
        'isTrial',
        'autoRenewStatusChangeDate',
        'expiresDate'
    ],
    type: 'object'
};
const EVENT_INFO_PROPERTY = {
    $ref: '#/definitions/EventInfo'
};
const EVENT_TYPE_DEFINITION = {
    enum: [
        'CANCEL',
    ],
    type: 'string'
};
const EVENT_TYPE_PROPERTY = {
    $ref: '#/definitions/EventType'
};
exports.BoomiOrderCancelSchema = {
    ...boomi_order_default_1.BoomiOrderDefaultSchema,
    definitions: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.definitions,
        EventInfo: EVENT_INFO_DEFINITION,
        EventType: EVENT_TYPE_DEFINITION,
    },
    properties: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.properties,
        eventInfo: EVENT_INFO_PROPERTY,
        eventType: EVENT_TYPE_PROPERTY,
    }
};
//# sourceMappingURL=data:application/json;base64,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